import { DeviceService } from '@/services/device.service'
export default {
  data() {
    return {
      dataUser: JSON.parse(localStorage.getItem('userData')),
    }
  },
  methods: {
    checkStatusPermission(status, perrmission) {
      return status === 'NEW' && this.dataPermission.includes(perrmission)
    },
    checkStatusAwaitApprove(status, perrmission) {
      return status === 'WAIT_APPROVE' && this.dataPermission.includes(perrmission)
    },
    checkStatusAwaitReceive(status, perrmission) {
      return status === 'WAIT_RECEIVE' && this.dataPermission.includes(perrmission)
    },
    checkStatusWaitProgress(status, perrmission) {
      return status === 'WAIT_PROGRESS' && this.dataPermission.includes(perrmission)
    },
    checkStatusInProgress(status, perrmission) {
      return status === 'IN_PROGRESS' && this.dataPermission.includes(perrmission)
    },
    checkSendApprove(status, perrmission) {
      return (
        (status === 'IN_PROGRESS' || status === 'NEW') && this.dataPermission.includes(perrmission)
      )
    },
    checkReject(status, perrmission) {
      return (
        (status === 'WAIT_APPROVE' || status === 'WAIT_RECEIVE') &&
        this.dataPermission.includes(perrmission)
      )
    },
    checkCancel(status, perrmission) {
      return (
        (status === 'NEW' || status === 'IN_PROGRESS' || status === 'WAIT_APPROVE') &&
        this.dataPermission.includes(perrmission)
      )
    },
    detailWarranty(id) {
      const routeData = this.$router.resolve({
        path: `/warranty/${id}`,
      })
      window.open(routeData.href, '_blank')
    },
    edit(id) {
      this.$router.push({
        path: `/warranty/edit/${id}`,
      })
    },
    sendApproveItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn gửi duyệt phiếu bảo hành ${item.code} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Gửi duyệt phiếu bảo hành',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.showLoading = true
            const res = await DeviceService.sendApproveWarranty({
              id: item.id,
            })
            this.showLoading = false
            if (res.code === 1000) {
              this.showSuccessMx(`Gửi duyệt phiếu bảo hành thành công`)
              this.fetchData()
            } else this.showFailMx(res.message)
          }
        })
        .catch(() => {
          this.showLoading = false
        })
    },
    sendReceiveItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn tiếp nhận phiếu bảo hành ${item.code} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Tiếp nhận bảo hành',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.showLoading = true
            const res = await DeviceService.receiveWarranty({
              id: item.id,
            })
            this.showLoading = false
            if (res.code === 1000) {
              this.showSuccessMx(`Tiếp nhận bảo hành thành công`)
              this.fetchData()
            } else this.showFailMx(`${res.message}`)
          }
        })
        .catch(() => {
          this.showLoading = false
        })
    },
    approveItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn duyệt phiếu bảo hành ${item.code} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Duyệt phiếu bảo hành',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.showLoading = true
            const res = await DeviceService.approveWarranty({
              id: item.id,
            })
            this.showLoading = false
            if (res.code === 1000) {
              this.showSuccessMx(`Duyệt phiếu bảo hành thành công`)
              this.fetchData()
            } else this.showFailMx(`${res.message}`)
          }
        })
        .catch(() => {
          this.showLoading = false
        })
    },
    rejectItem(item) {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('textarea', { ref: 'rejectValue', class: 'form-control f12' }),
      ])
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lý do từ chối',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false,
        })
        .then(async value => {
          if (value) {
            this.showLoading = true
            const action = item.status === 'WAIT_RECEIVE' ? 'REJECT_RECEIVE' : 'REJECT_APPROVE'
            const res = await DeviceService.rejectWarranty({
              id: item.id,
              reasonReject: this.$refs.rejectValue.value,
              action,
            })
            this.showLoading = false
            if (res.code === 1000) {
              this.showSuccessMx(`Từ chối phiếu bảo hành thành công`)
              this.fetchData()
            } else {
              this.showFailMx(res.message)
            }
          }
        })
        .catch(error => {
          this.showLoading = false
          this.showFailMx(error.message)
        })
    },
    cancelItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn huỷ phiếu bảo hành ${item.code} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Hủy phiếu bảo hành',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.showLoading = true
            const res = await DeviceService.cancelWarranty({
              id: item.id,
            })
            this.showLoading = false
            if (res.code === 1000) {
              this.showSuccessMx(`Huỷ phiếu bảo hành thành công`)
              this.fetchData()
            } else this.showFailMx(res.message)
          }
        })
        .catch(() => {
          this.showLoading = false
        })
    },
  },
}
